import {
  Button,
  Flex,
  Span,
  Link,
  styled,
  Card,
  Themes,
  SearchSelect,
  Grid,
  Table,
  Label
} from '@fareye/ui'
import { MdStar, MdStarBorder } from '@fareye/utils'
import SaveFavourites from '../modules/GlobalSearch/components/SaveFavourites'

export const HeaderFrame: any = styled(Flex)`
  width: 100%;
  gap: 1vmax;
  line-height: 1.25em;
  padding: 0.625vw 1vw;
  font-family: Roboto;
  flex-direction: column;
  box-sizing: border-box;
  ${(props: any) => ({
    zIndex: props.theme.global.zIndex.pageHeader,
    backgroundColor: props.theme.colors.default.background,
    boxShadow: `0 2px 4px 0 ${props.theme.colors.default.boxShadow}`
  })};
`

export const HeaderRow = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: calc(50% - 80px) 160px calc(50% - 80px);
  grid-template-areas: 'header-row-item-1 header-row-item-2 header-row-item-3';
  @media (max-width: 825px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-areas:
      'header-row-item-1 header-row-item-2'
      'header-row-item-3 header-row-item-3';
  }
`

export const HeaderRowItem1 = styled.div`
  grid-area: header-row-item-1;
  display: flex;
`
export const HeaderRowItem2 = styled.div`
  grid-area: header-row-item-2;
  justify-self: center;
  @media (max-width: 425px) {
    justify-self: end;
  }
`
export const HeaderRowItem3 = styled.div`
  grid-area: header-row-item-3;
  display: flex;
  justify-content: ${({ showRefreshed = false }: { showRefreshed?: boolean }) =>
    showRefreshed ? 'space-between' : 'flex-end'};
  align-items: center;
  @media (max-width: 425px) {
    flex-direction: column;
    align-items: flex-end;
    gap: 0.5em;
    margin-top: 0.5em;
  }
`

export const HeaderBody = styled.div`
  display: flex;
  width: 100%;
`

export const GroupedButton: any = styled(Flex)`
  width: 100%;
  > * {
    margin: 0;
    border-radius: 0;
    &:nth-child(1) {
      border-radius: 3px 0 0 3px;
    }
    &:last-child {
      border-radius: 0 3px 3px 0;
    }
  }
`

export const SearchFavouriteContainer = styled.div.attrs(() => ({
  className: 'search-favorite-container'
}))`
  width: 100%;
  display: flex;
  margin-right: 8px;
  @media (max-width: 467px) {
    flex-direction: column;
  }
`

export const SaveFavouritesBtn = styled(SaveFavourites)`
  @media screen and (max-width: 425px) {
    margin-right: unset;
  }
`

export const BreadToggleLastDate: any = styled(Flex)`
  flex-direction: row;
  width: 100%;
  @media (max-width: 992px) {
    flex-wrap: wrap;
    .toggle-container {
      margin-left: auto;
    }
  }
  .breadcrumb-container {
    width: 40%;
  }
  .toggle-container {
    width: 60%;
  }
`
export const LastRefreshedDate: any = styled(Flex)`
  flex: 1;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 992px) {
    flex: auto;
    margin-top: 4px;
    width: 100%;
  }
`

export const DateWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const LastRefreshed = styled(Span).attrs(() => ({
  className: 'last-refreshed'
}))<{ isLast: boolean }>`
  width: auto;
  justify-self: ${({ isLast }) => (isLast ? 'end' : 'center')};
  @media (max-width: 425px) {
    font-size: 11px;
    justify-self: start;
  }
`

export const SearchLocalWrapper = styled.div`
  display: contents;
  padding: 0 1em;
  @media (max-width: 425px) {
    padding: 0;
  }
`

export const SetFavourite: any = styled(Flex)`
  border-color: #b3b3b3;
  border-width: 1px;
  border-left-width: 0;
  border-right-width: 0;
  border-style: solid;
  border-color: #b3b3b3;
  border-radius: 0;
  padding-right: 10px;
  color: ${(props: any) => props.theme.colors.blue6};
  &:hover {
    border-color: #b3b3b3;
  }
`

export const FavButton = styled(Button)`
  svg {
    color: ${props => props.theme.colors.blue6};
  }
  &:hover {
    svg {
      color: ${props => props.theme.colors.blue5};
    }
    color: ${props => props.theme.colors.blue5};
  }
`

export const SMdStar = styled(MdStar)`
  stroke-width: 1;
  color: ${props => props.theme.colors.blue6};
  &:hover {
    color: ${props => props.theme.colors.blue5};
  }
`

export const SearchButton = styled(Button)`
  border-color: #b3b3b3;
  border-radius: 0 4px 4px 0;
  border-left: none;
  &:hover {
    border-color: #b3b3b3;
  }
`

export const Breadcrumbs: any = styled(Flex)`
  display: inline-flex;
  width: auto;
`

export const BreadcrumbItem = styled(Link)`
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const EndCirle = styled.div`
  box-sizing: border-box;
  height: 6px;
  width: 6px;
  opacity: 0.9;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: #727272;
`

export const StartCirle = styled.div`
  box-sizing: border-box;
  height: 7px;
  width: 7px;
  border: 1px solid #727272;
  opacity: 0.9;
  flex-shrink: 0;
  background: #fff;
  border-radius: 50%;
`

export const StoryTimeLine = styled.div`
  box-sizing: border-box;
  height: 14px;
  width: 2px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 1px dotted #979797;
  margin-left: 2px;
  margin-top: -11px;
  margin-bottom: 3px;
`
export const HideSlug = styled(Span)`
  display: none;
  font-size: 12px;
`

export const OverviewCard = styled(Card)`
  background: #fff;
  min-width: 410px;
  margin: 0 5px;
`

export const TextDisplay = styled.div`
  background-color: #eaf0f7;
  font-size: 12px;
  padding: 10px;
`

export const FiltersList = styled.div`
  display: flex;
`

export const asyncSearchStyle = {
  container: (base: any) => ({
    ...base,
    flexGrow: 1,
    borderRadius: '4px 0 0 4px',
    borderRight: 'none'
  }),
  control: (base: any) => ({
    ...base,
    borderRadius: '4px 0 0 4px',
    borderRight: 'none',
    borderColor: '#b3b3b3',
    boxShadow: 'none'
  }),
  option: (base: any) => ({
    ...base,
    display: 'flex',
    justifyContent: 'space-between',
    zIndex: 10
  })
}

export const searchStyle = {
  wrapper: {
    height: 'auto',
    padding: 1,
    background: '#fff'
  },
  container: (base: any) => ({
    ...base,
    flexGrow: 1,
    border: 'none'
  }),
  control: (base: any) => ({
    ...base,
    border: 'none',
    boxShadow: 'none'
  }),
  option: (base: any) => ({
    ...base,
    display: 'flex',
    justifyContent: 'space-between',
    zIndex: 10
  })
}

export const searchFavouritesWrapperStyle = {
  border: '1px solid #b8b8b8',
  borderRadius: 2,
  margin: 1,
  width: '100%',
  maxWidth: '25em'
}

export const saveFavouriteButtonStyle = {
  minWidth: 165,
  color: Themes.ant.colors.blue6,
  background: '#f0f2f5',
  alignItems: 'center',
  justifyContent: 'center'
}

export const popoverWrapperStyle = {
  wrapper: { padding: '12px 5px', background: '#f0f2f5' }
}

export const popoverBodyStyle = {
  background: '#ddebf0',
  marginTop: 1,
  overflow: 'hidden'
}

export const FavStar: any = styled(MdStarBorder)`
  margin-right: 10px;
  @media (max-width: 540px) {
    margin-right: 5px;
  }
`

export const Pill = styled(Button).attrs({ variant: 'primary' })`
  border-radius: 18px;
  padding: 7px 14px;
  flex: none;
  margin-right: 10px;
  ${(props: any) =>
    props.ghost
      ? {
          color: props.theme.colors.primary.color,
          border: `1px solid ${props.theme.colors.primary.background}`
        }
      : {}};
`

export const MapWrapper: any = styled(Flex)`
  flex: 1;
  z-index: 0;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  height: 100%;
  @media screen and (max-width: 425px) {
    flex-direction: column;
  }
`

export const TableWrapper = styled.div`
  padding: 15px;
  box-sizing: border-box;
`

export const TimeLineTable: any = styled(Table)`
  table {
    border: 0;
    tr {
      background: #fff;
      th,
      td {
        border: 0;
        overflow: visible;
      }
    }
  }
  ${(props: any) =>
    props.variant?.includes('card')
      ? `{
    table {
      border-spacing: 0 4px;
      tr:nth-child(even) {
        transform: translateY(-4px);
      }
    }
  }`
      : ``}
  ${(props: any) =>
    props.verticalAlign ? `table{td{vertical-align:text-top}}` : ``}
    ${(props: any) =>
      props.padding ? `table{td{padding:${props.padding}}}` : ``}
`

export const MapDetails: any = styled.div`
  height: 100%;
  min-width: 350px;
  width: 35%;
  max-width: 550px;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  background: #fff;
  ${(props: any) => (props.showMobileMenu ? { left: '100%' } : { right: 0 })}
  @media (max-width: 768px) {
    position: absolute;
    min-width: 250px;
    z-index: 1002;
    width: 90%;
    top: 0;
    height: 100%;
  }
`

export const FormGroup: any = styled(Flex)`
  margin: 5px 0 15px;
`

export const MobileMenu: any = styled.div<{ hideOnMobile: boolean }>`
  display: none;
  @media (max-width: 768px) {
    box-shadow: 0 0 10px -1px rgba(128, 128, 128, 0.5);
    position: fixed;
    bottom: 1em;
    left: 4em;
    background: #fff;
    border-radius: 50%;
    padding: 10px;
    display: flex;
  }
  @media (max-width: 425px) {
    left: 1em;
  }
`
// ====================== Vertical List ======================
export const AlertsContainer = styled(Grid)`
  height: 100%;
  overflow: hidden;
  padding: 10px;
  box-sizing: border-box;
  grid-gap: 0.625em;
  grid-template-columns: 200px auto;
  @media (max-width: 768px) {
    grid-template-columns: 100%;
    grid-template-rows: minmax(0, auto) 1fr;
  }
`

export const AlertTypeListing: any = styled(Flex)`
  box-shadow: 10px -2px 5px -6px rgba(230, 231, 231, 0.75);
  height: 100%;
  overflow: auto;
  @media (max-width: 768px) {
    display: none;
  }
`
export const AlertTypeSelect = styled(SearchSelect)`
  display: none;
  @media (max-width: 768px) {
    display: block;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    height: max-content;
  }
`
export const AlertType = styled(Span)`
  padding: 10px 15px;
  cursor: pointer;
  border-radius: 0px;
  ${(props: any) => `
    color: ${props.variant.includes('primary') ? '' : props.theme.colors.gray7};
    border-right: ${
      props.variant.includes('primary') ? '2px solid rgba(24,144,255)' : 'unset'
    };
  `}
`
// ====================== Vertical List ======================

export const SummaryFilterContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  @media (max-width: 425px) {
    justify-content: space-around;
  }
`

export const SearchSelectResponsive = styled.div`
  min-width: 120px;
  max-width: 130px;
  @media screen and (max-width: 669px) {
    width: 100%;
    max-width: 100%;
  }
`
export const GlobalSearchChildWrapper: any = styled(Flex)`
  @media screen and (max-width: 669px) {
    flex-wrap: wrap;
  }
`

export const HeaderFilterContainer = styled.div`
  display: flex;
  width: inherit;
  flex-direction: column;
  gap: 1em;
`

export const TypeSelectorAndSearch = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 0.5em;
  max-width: 80%;
  @media screen and (min-width: 426px) and (max-width: 769px) {
    max-width: unset;
  }
  @media screen and (max-width: 425px) {
    flex-direction: column;
    max-width: 100%;
  }
`
export const RWDSpan: any = styled(Span)`
  @media (max-width: 1920px) {
    font-size: 12px;
  }
  @media (max-width: 1440px) {
    font-size: 10px;
  }
  @media (min-width: 1921px) {
    font-size: 14px;
  }
`
export const RWDLink = styled(Link)`
  color: ${(props: any) => props.theme.colors.primary};
  @media (max-width: 1920px) {
    font-size: 12px;
  }
  @media (max-width: 1440px) {
    font-size: 10px;
  }
  @media (min-width: 1921px) {
    font-size: 14px;
  }
`
export const RWDLabel = styled(Label)`
  @media (max-width: 1920px) {
    font-size: 12px;
  }
  @media (max-width: 1440px) {
    font-size: 10px;
  }
  @media (min-width: 1921px) {
    font-size: 14px;
  }
`
